module.exports = __webpack_public_path__ + "img/00656bda30b93a2972dd6dab2153d37a.png";